export const DETECTION_COLORS = [
  '#FF6B6B', // vivid red
  '#FF9F1C', // bright orange
  '#FFBF69', // soft peach
  '#FFD166', // warm yellow
  '#06D6A0', // mint teal
  '#0EAD69', // emerald
  '#118AB2', // ocean blue
  '#1D3557', // deep navy
  '#4ECDC4', // turquoise
  '#2A9D8F', // sea green
  '#F4A261', // sandy orange
  '#E76F51', // salmon
  '#F94144', // crimson
  '#F8961E', // amber
  '#90BE6D', // olive green
  '#577590', // steel blue
  '#FF6F61', // coral
  '#5CB8E4', // sky blue
  '#38A3A5', // teal green
  '#22577A', // midnight blue
  '#F6BD60', // gold
  '#84A59D', // sage
  '#28C76F', // lime green
  '#17A2B8', // cyan
  '#FF8C42', // orange
  '#FF5A5F', // rose
  '#43AA8B', // emerald teal
  '#2F9C95', // jade
  '#3A86FF', // electric blue
  '#2C7DA0', // denim
  '#F3722C', // tangerine
  '#8D99AE'  // slate gray
];

export const getColorForClass = (classId = 0) => {
  const index = Math.abs(classId) % DETECTION_COLORS.length;
  return DETECTION_COLORS[index];
};

